"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkedAction = void 0;
/**
 * Builds a typed wire-action factory.
 *
 * @param type The action type discriminator.
 * @param schema Optional payload validator for inbound use.
 * @returns A factory `(payload) => { type, payload: { type, schema, toString, match } }`.
 *
 * @example
 * ```ts
 * const quickChat = networkedAction<{ text: string }>(
 *   "quickChat",
 *   z.object({ text: z.string() })
 * );
 * ```
 */
const networkedAction = (type, schema) => {
    const factory = ((payload) => ({
        type,
        payload,
    }));
    factory.type = type;
    factory.schema = schema;
    factory.toString = () => type;
    factory.match = (a) => a.type === type;
    return factory;
};
exports.networkedAction = networkedAction;
